import { Controller } from '@hotwired/stimulus';
import tippy from 'tippy.js';

export default class extends Controller {
  static targets = ['content', 'card'];

  connect() {
    this.popoverContent = this.contentTarget.cloneNode(true);
    this.popoverContent.classList.remove('d-none');

    this.tippyInstance = tippy(this.element, {
      content: this.popoverContent,
      interactive: true,
      trigger: 'mouseenter click',
      arrow: true,
      placement: 'bottom',
      theme: 'light-border',
      animation: 'shift-toward',
      maxWidth: 400,
      appendTo: () => document.body,
    });

    this.cardTargets.forEach((card) => {
      card.addEventListener('mouseenter', this.highlightDate);
    });
  }

  disconnect() {
    this.cardTargets.forEach((card) => {
      card.removeEventListener('mouseenter', this.highlightDate);
    });

    if (this.tippyInstance) {
      this.tippyInstance.destroy();
    }
  }

  highlightDate = (event) => {
    const date = event.currentTarget.dataset.date;
    this.popoverContent.querySelectorAll('.tc-deadline-popover-row').forEach((row) => {
      row.classList.toggle('tc-deadline-popover-row--highlighted', row.dataset.date === date);
    });
  };

}
